import { render, staticRenderFns } from "./sidebar-navigation-component.vue?vue&type=template&id=1a588d75&scoped=true&"
import script from "./sidebar-navigation-component.vue?vue&type=script&lang=ts&"
export * from "./sidebar-navigation-component.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-navigation-component.vue?vue&type=style&index=0&id=1a588d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a588d75",
  null
  
)

export default component.exports